// Qué decirle al vendedor cuando la agenda no carga, y si tiene sentido ofrecerle reintentar.
//
// Un problema de alta de RBAC no se arregla insistiendo: ofrecer «Reintentar» ahí le hace perder el
// turno probando un botón que nunca va a funcionar.
import { ApiError } from '@/api/errors';

export interface ListErrorCopy {
    title: string;
    description: string;
    /** Si es falso no se pinta el botón Reintentar: insistir no cambia el resultado. */
    canRetry: boolean;
}

export function prospectsErrorCopy(error: Error): ListErrorCopy {
    const code = error instanceof ApiError ? error.code : null;
    if (code === 'PERMISSION_DENIED') {
        return {
            title: 'No tienes permiso para ver tus prospectos',
            description:
                'Tu rol no incluye la agenda de prospectos. Si crees que es un error, contacta a quien administra los roles.',
            canRetry: false,
        };
    }
    return {
        title: 'No se pudo cargar la agenda de prospectos',
        description: error.message,
        canRetry: true,
    };
}
